import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "_flexcol" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_announcement_box = _resolveComponent("announcement-box")
  const _component_skeleton_banner = _resolveComponent("skeleton-banner")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($data.isInitialized)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          ($options.hasBanners)
            ? (_openBlock(), _createBlock(_component_announcement_box, {
                key: 0,
                banners: $data.banners
              }, null, 8 /* PROPS */, ["banners"]))
            : _createCommentVNode("v-if", true)
        ], 64 /* STABLE_FRAGMENT */))
      : (_openBlock(), _createBlock(_component_skeleton_banner, { key: 1 }))
  ]))
}